export default "__VITE_ASSET__C05C_YCf__"